module.exports = __webpack_public_path__ + "img/Logo.7b1ed82e.png";